<ng-select
  [items]="allSwitchTypes"
  [clearable]="false"
  bindLabel="title"
  bindValue="value"
  [formControl]="switchType"
  placeholder=""
></ng-select>
